import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import Spec from "csi/core/Spec";
import Time from "csi/heading/Time";
import locale from "csi/locale";
import declare from "dojo/_base/declare";

export = declare(Time, {
	/**
	 * @override
	 * now that we override toValue, should disable sort/filter functionality as well
	 */
	getQuerySpec(ctx: Context, h: Heading, spec: Spec) {
		return null;
	},

	/**
	 * @override
	 * format the value based on the status of stage
	 */
	toValue(ctx: Context, h: Heading) {
		const formattedValue = this.inherited(arguments);
		let currentNode = ctx.getNode();

		if (!!currentNode && !formattedValue) {
			if (currentNode.$Type !== "ProofStage") {
				currentNode = ctx.getNodeParent();
			}

			const thresholdType = currentNode.DueDateThreshold;
			let text = "";

			if (thresholdType > 0) {
				text = locale.resource("DueDateThresholdDays", [thresholdType]);
			} else if (thresholdType === 0) {
				text = locale.resource("DueDateStageStartDay");
			} else if (thresholdType === -1) {
				text = locale.resource("None");
			}

			return text;
		}

		return formattedValue;
	},
});